<template>
	<div>
		<Row>
			<Input v-model="name" style="width: 150px;margin-left: 10px;" placeholder="客户经理" @on-change="getList" />
			<Select v-model="department" clearable @on-change="getList" style="width:150px;margin-left: 20px;"
				placeholder="跟进团队">
				<Option v-for="item in departmentList" :value="item.value" :key="item.value">{{ item.label }}
				</Option>
			</Select>
			<Button type="primary" @click="initSearch()" style="margin-left: 20px;">刷新</Button>
			<Button type="primary" @click="saveAll()" style="margin-left: 20px;">批量保存</Button>		
			<Button type="primary" @click="saveDataAllClose('open')" style="margin-left: 20px;">全部开启数据</Button>
			<Button type="primary" @click="saveDataAllClose('close')" style="margin-left: 20px;">全部关闭数据</Button>
			<Button type="primary" @click="saveLoginAllClose('open')" style="margin-left: 20px;">全部开启登录</Button>
			<Button type="primary" @click="saveLoginAllClose('close')" style="margin-left: 20px;">全部禁止登录</Button>

		</Row>
		<div style="margin-top: 20px;">
			<Table size="small" :columns="columns" :data="data">
				<template slot-scope="{ index,row }" slot="name">
					<span style="color:#63B3E6;cursor: pointer;" @click.stop="goToMyCenter(row.id)">{{row.name}}</span>
				</template>
				<template slot-scope="{row, index}" slot="nums">
					<span v-if="index == 0" style="width: 60px">{{data[index].nums}}</span>
					<Input v-else v-model="data[index].nums" style="width: 60px" />
				</template>
				<template slot-scope="{row, index}" slot="limit_look_phone_nums">
					<span v-if="index == 0" style="width: 60px">{{data[index].limit_look_phone_nums}}</span>
					<Input v-else v-model="data[index].limit_look_phone_nums" style="width: 60px;text-align: center;" />
				</template>
				<template slot-scope="{row, index}" slot="user_permission">
					<i-switch v-model="data[index].user_permission">
						<span slot="open">开</span>
						<span slot="close">关</span>
					</i-switch>
				</template>
				<template slot-scope="{row, index}" slot="is_open">
					<i-switch v-model="data[index].is_open">
						<span slot="open">开</span>
						<span slot="close">关</span>
					</i-switch>
				</template>
				<template slot-scope="{row, index}" slot="is_allow_login">
					<i-switch v-model="data[index].is_allow_login">
						<span slot="open">开</span>
						<span slot="close">关</span>
					</i-switch>
				</template>
				<template slot-scope="{row, index}" slot="media_is_open">
					<i-switch v-model="data[index].media_is_open">
						<span slot="open">开</span>
						<span slot="close">关</span>
					</i-switch>
				</template>
				<template slot-scope="{row, index}" slot="action1">
					<CheckboxGroup v-model="data[index].medium_code_type">
						<Checkbox v-for="item in data[index].media_type_list" :label="item.id">
							<span>{{item.media_type_name}}</span>
						</Checkbox>
					</CheckboxGroup>
				</template>
				<template slot-scope="{row, index}" slot="action">
					<div>
						<span style="color: #0092FF;" @click.stop="save" :data-index="index">保存</span>
						<!--span style="color: red;" @click.stop="quit" :data-id="row.id">离职</span>
						<span style="color: #0092FF;" @click.stop="transform" :data-id="row.id">客户转移</span>
						<!--                        <span style="color: #FDB456;">休假</span>-->
					</div>
				</template>
			</Table>
		</div>
		<!-- 选择分配人 -->
		<Modal v-model="transformModal" width="650" title="选择转移人">
			<div class="multiple" style="margin-top: 0">
				<div class="child-div in-block">转移给</div>
				<RadioGroup v-model="transformUid" class="in-block" style="width: 80%">
					<Radio v-for="item in userList" :label="item.id"><span>{{item.name}}</span></Radio>
				</RadioGroup>
			</div>
			<div slot="footer">
				<Button type="primary" @click="transformBatch">确定</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {
		getUserList,
		getDepartmentList
	} from '@/api/user'
	import {
		getDepartmentUserList,
		saveDepartmentDataSet,
		saveDepartmentQuit,
		departmentTransform
	} from "../../api/task";
	import {
		mapGetters
	} from "vuex";

	export default {
		name: "StaffAdmin",
		components: {},
		data() {
			return {
				transformModal: false,
				transformUid: 0,
				transformOriginUid: 0,
				columns: [{
						title: '员工姓名',
						slot: 'name',
						"align": "center",
						"width": 70,
					},
					{
						title: '工号',
						key: 'userNum',
						"align": "center",
						"width": 100,
					},
					{
						title: '分公司',
						key: 'company_name',
						"align": "center",
						"width": 100,
					},
					{
						title: '所属部门',
						key: 'department_name',
						"align": "center",
						"width": 100,
					},
					{
						title: '角色',
						key: 'role_name',
						"align": "center",
						"width": 100,
					},
					{
						title: '是否允许登录',
						slot: 'is_allow_login',
						"align": "center",
						"width": 100,
					},
					{
						title: '在职状态',
						key: 'quit_name',
						"align": "center",
						"width": 100,
					},
					{
						title: '数据开关权限',
						slot: 'user_permission',
						"align": "center",
						"width": 100,
					},
					{
						title: '开关状态',
						slot: 'is_open',
						"align": "center",
						"width": 100,
					},
					{
						title: '媒体代码权限',
						slot: 'media_is_open',
						"align": "center",
						"width": 100,
					},
					{
						title: '当天数量',
						key: 'cur_nums',
						"align": "center",
						"width": 100,
					},
					{
						title: '数据量/天',
						slot: 'nums',
						"align": "center",
						"width": 100,
					},
					{
						title: '限制查看手机号数量',
						slot: 'limit_look_phone_nums',
						"align": "center",
						"width": 150,
					},
					{
						title: '当前查看手机号数量',
						key: 'cur_look_phone_nums',
						"align": "center",
						"width": 150,
					},
					{
						title: '操作管理',
						slot: 'action',
						"align": "center",
						"width": 150,
					},
				],
				columnsCopy: [{
						title: '员工姓名',
						slot: 'name',
						"align": "center",
						"width": 70,
					},
					{
						title: '工号',
						key: 'userNum',
						"align": "center",
						"width": 100,
					},
					{
						title: '分公司',
						key: 'company_name',
						"align": "center",
						"width": 100,
					},
					{
						title: '所属部门',
						key: 'department_name',
						"align": "center",
						"width": 100,
					},
					{
						title: '角色',
						key: 'role_name',
						"align": "center",
						"width": 100,
					},
					{
						title: '是否允许登录',
						slot: 'is_allow_login',
						"align": "center",
						"width": 100,
					},
					{
						title: '在职状态',
						key: 'quit_name',
						"align": "center",
						"width": 100,
					},
					{
						title: '数据开关权限',
						slot: 'user_permission',
						"align": "center",
						"width": 100,
					},
					{
						title: '开关状态',
						slot: 'is_open',
						"align": "center",
						"width": 100,
					},
					{
						title: '媒体代码权限',
						slot: 'media_is_open',
						"align": "center",
						"width": 100,
					},
					{
						title: '当天数量',
						key: 'cur_nums',
						"align": "center",
						"width": 100,
					},
					{
						title: '数据量/天',
						slot: 'nums',
						"align": "center",
						"width": 100,
					},
					{
						title: '限制查看手机号数量',
						slot: 'limit_look_phone_nums',
						"align": "center",
						"width": 150,
					},
					{
						title: '当前查看手机号数量',
						key: 'cur_look_phone_nums',
						"align": "center",
						"width": 150,
					},
					{
						title: '成本编辑',
						slot: 'action1',
						"align": "center",
						"width": 100,
					},
					{
						title: '操作管理',
						slot: 'action',
						"align": "center",
						"width": 150,
					},
				],
				data: [],
				userList: [],
				name: '',
				departmentList: [],
				department: ''
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted() {
			this.userType();
			this.loadData();
			this.getList();
		},
		methods: {
			async loadData() {
				let that = this;
				let data = {
					token: that.token
				};
				let res = await getUserList(that, data);
				if (res.code == 1) {
					that.userList = res.data.list;
				}
				res = await getDepartmentList(that, data);
				if (res.code == 1) {
					that.departmentList = res.data.list;
				}
			},
			userType() {
				// type: 4 分公司负责人   5 区长
				if (this.userInfo.role_type !== 1) {
					this.columns = this.columns.filter(col => col.slot !== 'media_is_open')
					this.columns = this.columns.filter(col => col.key !== 'company_name')
					this.columnsCopy = this.columnsCopy.filter(col => col.slot !== 'media_is_open')
				}

				if (this.userInfo.role_type !== 4 && this.userInfo.role_type !== 13 && this.userInfo.role_type !==
					1) { //此处判断不用用户类型是否有有对应的列权限
					this.columns = this.columns.filter(col => col.slot !== 'limit_look_phone_nums')
					this.columns = this.columns.filter(col => col.key !== 'cur_look_phone_nums')
				} else {
					if (this.userInfo.role_type == 13) {
						this.columns = this.columns.filter(col => col.slot !== 'limit_look_phone_nums')
					} else {
						this.columns = this.columnsCopy
					}
				}
				console.log(this.columns)
			},
			async getList() {
				let that = this;
				let data = {}
				data.token = this.token;
				data.name = this.name;
				data.department = this.department;
				let res = await getDepartmentUserList(that, data);
				this.data = res.data.list;
			},
			goToMyCenter(uid) {
				uid = Number(uid)
				this.$router.push({
					name: 'myCenter',
					query: {
						uid: uid,
					}
				})
			},
			save(e) {
				let that = this;
				let index = e.currentTarget.dataset.index;
				that.throttle(async function() {
					let data = that.data[index];
					data.token = this.token;
					let res = await saveDepartmentDataSet(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
					}
				}, 500)
			},
			initSearch() {
				this.department = '';
				this.name = '';
				this.getList();
			},
			saveLoginAllClose(type){
				let that = this;
				console.log(that.data)
				that.$Modal.confirm({
					title: '确定保存吗？',
					onOk: async () => {
						that.throttle(async function() {
							for (let i = 1; i < that.data.length; i++) {
								if(that.data[i].role_name == "分公司负责人"){
									
								}else{
									if(type == 'open'){
										that.data[i].is_allow_login = true;
									}else{
										that.data[i].is_allow_login = false;
									}									
								}

							}
							let data = that.data;
							data.shift(); //去掉数组第一项合计项
							let res = await saveDepartmentDataSet(that, {
								list: data,
								token: that.token,
							});
							if (res.code == 1) {
								that.$Message.success(res.msg);
								that.getList();
							}
						}, 500)
					}
				})
			},
			saveDataAllClose(type){
				let that = this;
				that.$Modal.confirm({
					title: '确定保存吗？',
					onOk: async () => {
						that.throttle(async function() {
							for (let i = 1; i < that.data.length; i++) {
								if(that.data[i].role_name == "分公司负责人"){
									
								}else{
									if(type == 'open'){
										that.data[i].is_open = true;
									}else{
										that.data[i].is_open = false;
									}									
								}
							}
							let data = that.data;
							data.shift(); //去掉数组第一项合计项
							let res = await saveDepartmentDataSet(that, {
								list: data,
								token: that.token,
							});
							if (res.code == 1) {
								that.$Message.success(res.msg);
								that.getList();
							}
						}, 500)
					}
				})
			},
			saveAll() {
				let that = this;
				console.log('执行没')
				that.$Modal.confirm({
					title: '确定保存吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = that.data;
							data.shift(); //去掉数组第一项合计项
							let res = await saveDepartmentDataSet(that, {
								list: data,
								token: that.token,
							});
							if (res.code == 1) {
								that.$Message.success(res.msg);
								that.getList();
							}
						}, 500)
					}
				})
			},
			quit(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认员工已经离职了吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								id: id
							}
							data.token = this.token;
							let res = await saveDepartmentQuit(that, data);
							if (res.code == 1) {
								that.$Message.success(res.msg);
								that.getList();
							}
						}, 500)
					}
				})
			},
			transform(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.transformOriginUid = id;
				that.transformModal = true;
			},
			transformBatch() {
				let that = this;
				that.throttle(async function() {
					let data = {
						originUid: that.transformOriginUid,
						uid: that.transformUid
					}
					data.token = this.token;
					let res = await departmentTransform(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.transformModal = false;
					}
				}, 500)
			}
		}
	}
</script>

<style scoped lang="less">
	.action_flex {
		width: 130px;
		display: flex;
		justify-content: space-between;

		span {
			cursor: pointer;
		}
	}

	.child-div {
		width: 20%;
	}

	.in-block {
		display: inline-block;
	}

	/deep/ .ivu-table table {
		width: 100% !important;
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #FF6699;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}

	/deep/ .client_name {
		display: inline-block;
		margin: 0 4px;
		color: #85c7ff;
	}
</style>
